export default __webpack_public_path__ + "static/media/map-dummy.1e2b6f90.png";